import apiClient from "@/services/api-client";

export const getNotificationApi = () => {
  return apiClient({
    method: "GET",
    url: `/v1/notifications`,
  });
};
